<template>
    <div>
        <div class="mt5" v-if="!finalNodeFlag">
            <button class='swb-btn swb-btn-mini mr10 fr' @click="refreshOaAuditRec()">刷新</button>
        </div>
        <div class="table-layout">
            <el-table :data="recList" border max-height="400" style="width: 100%">
                <el-table-column prop="nodeName" label="审批环节" width="200" align="left"></el-table-column>
                <el-table-column prop="auditorName" label="审核人" width="100" align="left"></el-table-column>
                <el-table-column prop="auditStatusStr" label="审核状态" width="100" align="center">
                    <template slot-scope="rows">
                    <span v-if="rows.row.nodeId != '提报'">
                        <span>{{ rows.row.auditStatusStr || '' }}</span>
                    </span>
                        <span v-else>已提报</span>
                    </template>
                </el-table-column>
                <el-table-column prop="auditDesc" label="审核描述" align="left"></el-table-column>
                <el-table-column prop="finalNodeFlag" label="是否终审" width="80" align="center">
                    <template slot-scope="rows">
                        <span v-if="rows.row.finalNodeFlag">是</span>
                    </template>
                </el-table-column>
                <el-table-column prop="ts" label="审核时间" width="160" align="center"></el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
import { Utils } from '../../app.base'
import { MsgBox } from '../../app.vues'

import oaAuditApi from '../../api/oaAudit'

export default {
    name: 'swb-oa-audit-rec-list',
    desc: '审核记录',
    props: {
        bizVoucherNo: {
            type: String,
            default: null
        },
        bizTypeCode: {
            type: String,
            default: null
        },
        auditSeqNo: {
            type: Number,
            default: null
        }
    },
    data: function () {
        return {
            recList: [],
            finalNodeFlag: true
        }
    },
    created: function () {
        this.getMerchtAuditBpRecsByBizVoucherNo();
    },
    methods: {
        getMerchtAuditBpRecsByBizVoucherNo: function () {
            let self = this;
            let params = {
                bizVoucherNo: this.bizVoucherNo,
                bizTypeCode: this.bizTypeCode,
                auditSeqNo: this.auditSeqNo
            };
            //
            let theLoad = MsgBox.loading();
            oaAuditApi.getMerchtAuditBpRecsByBizVoucherNo(params, function (result) {
                theLoad.hide();
                if(result.type === 'info') {
                    let recList = result.data || [];
                    let finalNodeFlags = recList.pluck('finalNodeFlag');
                    self.finalNodeFlag = finalNodeFlags.indexOf(true) >= 0;
                    self.recList = Utils.merge([], recList);
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        refreshOaAuditRec: function () {
            let self = this;
            let postData = {
                bizVoucherNo: this.bizVoucherNo,
                bizTypeCode: this.bizTypeCode,
                auditSeqNo: this.auditSeqNo
            };
            let theLoad = MsgBox.loading('请稍后...');
            oaAuditApi.saveBizVoucherRecForFeishuAudit(postData, function (result) {
                theLoad.hide();
                if(result.type === 'info') {
                    //
                    self.getMerchtAuditBpRecsByBizVoucherNo();
                    self.$message.success('刷新成功');
                } else {
                    MsgBox.warning(result.message);
                }
            });
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/compo/oaAudit/AuditBpRecsList.vue